module.exports = __webpack_public_path__ + "img/sexygaming.e26e3e25.jpg";